import { useCurrency } from '@bz/common';
import { useSystemAssets } from '@bz/systemAssets';

import { formateUsdtNum } from '../../utils';

import { getCurrencyIcon } from '~/utils';

export default function CreditTipsDialog() {
  const { walletCreditInfo } = useCurrency();
  const [assets] = useSystemAssets();
  function handleClose() {
    pop.pop();
  }
  return (
    <div class="pt-[3.5rem] text-center">
      <div class="flex flex-col gap-4 items-center justify-center pt-3 ">
        <h2 class="text-[1rem] font-semibold text-neutral-main1">{t('VIP Credits Granted')}</h2>
        <div class="flex items-center">
          <img class="size-[2rem] mr-1" src={getCurrencyIcon('USDT', false)} alt="currencyIcon" srcset="" />
          <span class="text-[1.62rem] font-semibold text-function-highlight">
            {formateUsdtNum(walletCreditInfo()?.totalBalance)}
          </span>
        </div>
        <div class="text-neutral-main3 text-sm w-[23.75rem] text-center">
          {t('Your exclusive safety net-place bets instantly even when your cash runs low.')}
        </div>
        <div class="bg-layer4 rounded-lg border-main2-auto px-6 py-4">
          <div class={`relative rounded-md h-7 text-xs font-semibold text-neutral-main1 center gap-2 `}>
            <img class="w-[22.5rem] no-filter" src={assets.Credit} alt="Credit" />
            <span class="inline-block w-[22.5rem] px-4 text-left absolute left-50% top-50% -translate-x-50% -translate-y-50%  font-semibold text-neutral-main1">
              {t('Use VIP Credits ')}
              <span class="text-function-highlight">
                ({t('Balance: ')}
                {formateUsdtNum(walletCreditInfo()?.totalBalance)}
                {t(' USDT')})
              </span>
            </span>
          </div>
          <div class="notice-box mt-4">
            <div class="text-neutral-main1 text-[1rem] font-semibold">{t('Play Only, No Withdrawals')}</div>
            <div class="text-neutral-main3 mt-2 text-sm font-[500]">
              {t('Credit funds can be used on any game but cannot be directly withdrawn.')}
            </div>
          </div>
        </div>
        <div class="bg-layer4 rounded-lg border-main2-auto text-center px-6 py-4">
          <IconWinning class={`size-16 mx-auto text-neutral-main1 `} />
          <div class="notice-box mt-4">
            <div class="text-neutral-main1 text-[1rem] font-semibold">{t('Winnings Paid in Cash')}</div>
            <div class="text-neutral-main3 mt-2 text-sm font-[500]">
              {t(
                'All your winnings from credit bets will be credited directly to your Cash Balance, fully withdrawable.'
              )}
            </div>
          </div>
        </div>
        <div class="bg-layer4 rounded-lg border-main2-auto text-center px-6 py-4">
          <IconSettlement class={`size-16 mx-auto text-neutral-main1 `} />
          <div class="notice-box mt-4">
            <div class="text-neutral-main1 text-[1rem] font-semibold">{t('Monthly Statement Settlement')}</div>
            <div class="text-neutral-main3 mt-2 text-sm font-[500]">
              {t(
                'Play this month, settle next month. Repay your used credit easily through your monthly billing statement.'
              )}
            </div>
          </div>
        </div>
      </div>
      <Button class="w-full mt-4" type="brand" onClick={() => handleClose()}>
        {t('Got It')}
      </Button>
    </div>
  );
}
